'use client';
'use strict';

var react = require('react');

const useRadioCard = ({ checked, disabled, onChange })=>{
    const [isHover, setIsHover] = react.useState(false);
    const [isSelected, setIsSelected] = react.useState(checked);
    const handleChange = react.useCallback((e)=>{
        if (disabled) return;
        setIsSelected((prev)=>!prev);
        if (onChange) onChange(e);
    }, [
        onChange,
        disabled
    ]);
    const hoverListItemContainer = ()=>{
        setIsHover(true);
    };
    const unhoverListItemContainer = ()=>{
        setIsHover(false);
    };
    return {
        isHover,
        isSelected,
        handleChange,
        hoverListItemContainer,
        unhoverListItemContainer
    };
};

module.exports = useRadioCard;
